import { inject, ref, Ref } from 'vue';
import {
  isGuestFromAnalyticsPageKey,
  reportFromAnalyticsPageKey,
  reportIdFromAnalyticsPageKey,
} from '@/ui/injectionKeys';
import { ReportRecordData } from '@/services/api/resources/analytics-builder/model';

export const useReportInjection = () => {
  const isGuest = inject<boolean>(isGuestFromAnalyticsPageKey, false);
  const reportId = inject<Ref<number | null>>(reportIdFromAnalyticsPageKey, ref(null));
  const report = inject<Ref<ReportRecordData | null>>(reportFromAnalyticsPageKey, ref(null));

  return {
    isGuest,
    reportId,
    report,
  };
};
